import React from 'react';
import * as LucideIcons from 'lucide-react';
import { IconElement as IconType } from '../../types/element.types';

interface IconElementProps {
  element: IconType;
}

/**
 * Icon Element Renderer
 * Renders Lucide icons
 */
const IconElement: React.FC<IconElementProps> = ({ element }) => {
  const { iconName } = element.content || { iconName: 'Star' };
  const size = element.settings?.size || '24px';

  // Get the icon component from Lucide
  const IconComponent = (LucideIcons as any)[iconName] || LucideIcons.Star;

  return (
    <div
      className="icon-element inline-flex"
      style={element.styles as React.CSSProperties}
    >
      <IconComponent size={parseInt(size)} />
    </div>
  );
};

export default IconElement;

